import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import {
  clockIn,
  clockOut,
  getActiveClock,
  getTimeClockByPayPeriod
} from "actions/account";
import { MSpinner } from "components/Shared";
import { TimeLogs } from "components/User";
import {
  getCaseTimeLogByUserPayPeriod,
  getPayPeriodList
} from "actions/casetimelog";
import { ClockInOutCard, ProductionTimeCard } from "../../Shared/TimeLogs";
import { CaseTimeLogWorkTypeEnum } from "interfaces/Mueller.Business.Models";
import SchedulingAssistantSummaryCard from "./SchedulingAssistantSummaryCard";
import { SchedulingAssistantFieldSet } from "components/User/TimeLogs";

interface Props {
  updatingUser: boolean;
  isFetchingActiveClock: boolean;
  activeClock: object;
  getActiveClock: Function;
  clockIn: Function;
  clockOut: Function;
  getCaseTimeLogByUserPayPeriod: Function;
  getPayPeriodList: Function;
  isFetchingTimeLogs: boolean;
  timeLogs: Array<any>;
  isFetchingPayPeriods: boolean;
  payPeriods: Array<any>;
  timeClockByPayPeriod: Array<any>;
  isFetchingTimeClockByPayPeriod: boolean;
  getTimeClockByPayPeriod: Function;
  isFetchingTimeLogByDaySummary: boolean;
  timeLogByDaySummary: object;
  getTimeLogByDaySummary: Function;
};

const SATimeLogs = ({
  updatingUser,
  isFetchingActiveClock,
  activeClock,
  getActiveClock,
  clockIn,
  clockOut,
  getCaseTimeLogByUserPayPeriod,
  getPayPeriodList,
  isFetchingTimeLogs,
  timeLogs,
  isFetchingPayPeriods,
  payPeriods,
  timeClockByPayPeriod,
  isFetchingTimeClockByPayPeriod,
  getTimeClockByPayPeriod,
}: Props) => {
  const [selectedPayPeriodIndex, setSelectedPayPeriodIndex] = useState(0);
  const [filterDate, setFilterDate] = useState<Date>();
  const [refreshSummaryCard, setRefreshSummaryCard] = useState<Date>(null);

  useEffect(() => {
    getPayPeriodList();
  }, []);
  
  if (isFetchingPayPeriods) {
    return <MSpinner />;
  }

  return (
    <Grid container spacing={2} className="sa-timelogs" padding={1}>
      <Grid size={6}>
        <TimeLogs
          isFetchingTimeLogs={isFetchingTimeLogs}
          timeLogs={timeLogs}
          payPeriods={payPeriods}
          isFetchingPayPeriods={isFetchingPayPeriods}
          getCaseTimeLogByUserPayPeriod={
            getCaseTimeLogByUserPayPeriod
          }
          getPayPeriodList={getPayPeriodList}
          displayJustSummaryCard={true}
          callBackPayPeriod={setSelectedPayPeriodIndex}
          selectedPayPeriodIndex={selectedPayPeriodIndex}
          fieldSet={SchedulingAssistantFieldSet}
        />
      </Grid>
      <Grid size={6}>
        <ClockInOutCard
          activeClock={activeClock}
          displayClockInOutButton={true}
          data={timeClockByPayPeriod}
          isFetchingData={isFetchingTimeClockByPayPeriod}
          payPeriod={
            payPeriods[selectedPayPeriodIndex]
          }
          getData={getTimeClockByPayPeriod}
          getActiveClock={getActiveClock}
          isFetchingActiveClock={isFetchingActiveClock}
          clockIn={clockIn}
          clockOut={clockOut}
          updatingUser={updatingUser}
        />
      </Grid>
      <Grid size={6}>
        <ProductionTimeCard
          data={timeLogs}
          isFetchingData={isFetchingTimeLogs}
          filterDate={filterDate}
          payPeriod={payPeriods[selectedPayPeriodIndex]}
          getData={getCaseTimeLogByUserPayPeriod}
          internetUserId={0}
          workTypeId={CaseTimeLogWorkTypeEnum.FS_SCHEDULING}
        />
      </Grid>
      <Grid size={6}>
        <SchedulingAssistantSummaryCard
          internetUserId={0}
          payPeriodId={payPeriods[selectedPayPeriodIndex].id}
          onDateClicked={setFilterDate}
          refreshCard={refreshSummaryCard}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  updatingUser: state.user.updatingUser,
  isFetchingActiveClock: state.user.isFetchingActiveClock,
  activeClock: state.user.activeClock,
  isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs,
  timeLogs: state.caseTimeLog.timeLogs,
  isFetchingPayPeriods: state.caseTimeLog.isFetchingPayPeriods,
  payPeriods: state.caseTimeLog.payPeriods,
  timeClockByPayPeriod: state.user.timeClockByPayPeriod,
  isFetchingTimeClockByPayPeriod: state.user.isFetchingTimeClockByPayPeriod,
  isFetchingTimeLogByDaySummary: state.qualityAssurance.isFetchingTimeLogByDaySummary,
});

const mapDispatchToProps = dispatch => ({
  getActiveClock(timeZoneOffset) {
    dispatch(getActiveClock(timeZoneOffset));
  },
  clockIn(timeZoneOffset) {
    dispatch(clockIn(timeZoneOffset));
  },
  clockOut(timeZoneOffset) {
    dispatch(clockOut(timeZoneOffset));
  },
  getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId) {
    dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
  },
  getPayPeriodList() {
    dispatch(getPayPeriodList());
  },
  getTimeClockByPayPeriod(internetUserId, payPeriodId) {
    dispatch(getTimeClockByPayPeriod(internetUserId, payPeriodId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SATimeLogs);
